export default __webpack_public_path__ + "static/media/profile-bg.6555544b.jpg";